import { AccountInfo, AccountInfoCompany } from "./reducer";

export const TransformAuthResponse = (response: AuthResponse): AccountInfo => {
  return {
    apiKey: response.apiKey,
    partnerId: response.id,
    companyCity: response.companyCity,
    companyCountry: response.companyCountry,
    companyName: response.companyName,
    companyPostalCode: response.companyPostalCode,
    companyStreet: response.companyStreet,
    companyVatId: response.companyVatId,
    firstName: response.firstName,
    lastName: response.lastName,
    mail: response.mail,
    showBiddingType: response.showBiddingType,
    showPlatformSelection: response.showIosOption,
    hasReadOnlyAccess:
      response.hasReadOnlyAccess !== undefined
        ? response.hasReadOnlyAccess
        : false,
    companies: response.companies ? response.companies : [],
    specialMode: response.specialMode,
    isROASCampaignsEnabled: response.isROASCampaignsEnabled,
    isNotificationManagerEnabled: response.isNotificationManagerEnabled,
  };
};

export interface AuthResponse {
  jwtToken: string;
  // the partner's own id; `partnerId` in AccountInfo, since `id` alone is
  // ambiguous next to the company ids
  id?: number;
  mail: string;
  firstName: string;
  lastName: string;
  companyName: string;
  companyStreet: string;
  companyCity: string;
  companyPostalCode: string;
  companyCountry: string;
  companyVatId: string | null;
  apiKey: string;
  showBiddingType: boolean;
  showIosOption: boolean;
  companies: AccountInfoCompany[];
  hasReadOnlyAccess: boolean;
  specialMode?: "main" | "am";
  isROASCampaignsEnabled: boolean;
  isNotificationManagerEnabled: boolean;
}
